import React, { useCallback, useEffect, Fragment } from 'react';
import { Button } from '@material-ui/core';
import BookingFormStore from 'Stores/BookingFormStore';
import WhiteLabelReturn from 'Components/Front/Booking/WhiteLabelBookingReturn';
import ServiceCard from 'Components/Front/ServiceCard';
import getBookingIdentifier from 'Functions/getBookingIdentifier';
import bemit from 'Functions/bemit';
import { getTotalServiceAmount } from 'Shared/utilities';
import { formatNum, num } from 'Shared/utilities';
export default function BookingServicesStep({
  ...props
}) {
  const picked_services = BookingFormStore.useState(s => s.picked_services);
  const services_count = BookingFormStore.useState(s => s.services_count);
  const some__picked = BookingFormStore.useState(s => s.has__picked_service);
  const hours_count = BookingFormStore.useState(s => num(s.hours_count, 0));
  const categories = BookingFormStore.useState(s => s.services_categories);
  const amount = BookingFormStore.useState(s => s.amount);
  const people = BookingFormStore.useState(s => s.people);
  const errors = BookingFormStore.useState(s => s.status_messages || {});
  const start = BookingFormStore.useState(s => s.start);
  const step = BookingFormStore.useState(s => s.step);
  const end = BookingFormStore.useState(s => s.end);
  const getService = useCallback(function (id) {
    let match;
    (categories || []).find(function (category) {
      match = category.__services.find(service => service.id === id);
      return match ? true : false;
    });
    return match;
  }, [categories]);
  const getPickedServices = useCallback(function () {
    const services = [];
    Object.keys(picked_services || {}).filter(name => num(picked_services[name], 0) > 0).forEach(function (name) {
      const quantity = num(picked_services[name], 0);
      const service_id = name.split('qty_')[1];
      const service = {};
      const info = getService(service_id);
      if (!info) return;
      service.service_info = {
        ...info,
        title: info?._servicetitle?.title || ''
      };
      service.total_price = getTotalServiceAmount({
        service: service.service_info,
        quantity: quantity,
        hours_count: hours_count
      });
      service.quantity = quantity;
      services.push(service);
    });
    return services;
  }, [getService, picked_services, start, end, hours_count]);
  useEffect(function () {
    BookingFormStore.update(function (store) {
      store.has__picked_service = Object.keys(picked_services || {}).some(name => num(picked_services[name], 0) > 0);
      const services = getPickedServices();
      const services_cost = services.reduce(function (services_cost, service) {
        return num(services_cost + num(service.total_price));
      }, 0);
      store.services = services;
      store.amount = num(window.localStorage.getItem('amount'));
      const grand_total = num(num(window.localStorage.getItem('amount')) + services_cost);
      store.grand_total = grand_total;
    });
  }, [picked_services, getPickedServices]);
  const nextStep = useCallback(function (e) {
    const services = getPickedServices();
    const services_amount = services.reduce(function (total, service) {
      return num(total + num(service.total_price));
    }, 0);
    window.localStorage.setItem('services_picked', getBookingIdentifier());
    const services_details = services.map(function (service) {
      return {
        id: service.service_info?.id,
        qty: num(service.quantity, 0)
      };
    });
    window.localStorage.setItem('services_details', JSON.stringify(services_details));
    BookingFormStore.update(function (store) {
      store.step = 1;
      store.services = services;
      store.amount = formatNum(window.localStorage.getItem('amount'), '0.00');
      store.grand_total = num(services_amount + num(amount));
    });
    props.onStepChange?.(1);
  }, [props.onStepChange, getPickedServices]);
  if (step !== 0) return null;
  const services = (categories || []).map(function (category, i) {
    // mobile & tablet
    const has__widget = window.innerWidth > 1200 && i === 0;
    const modifiers = ['front'].concat(has__widget ? ['with-widget'] : []);
    if (props['white-label-booking']) {
      modifiers.push('white-label-booking');
    }
    const services = category.__services.map(function (service, i) {
      const output = /*#__PURE__*/React.createElement(ServiceCard, {
        key: service.id,
        service: service,
        status: errors,
        value: picked_services['qty_' + service.id],
        people: people,
        start: start,
        end: end,
        bemit: modifiers,
        category: category,
        "hide-category": i > 0
      });
      return output;
    });
    const output = /*#__PURE__*/React.createElement(Fragment, {
      key: category.value
    }, services);
    return output;
  });
  const next_btn = /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-flat-btn', ['blue', 'v2', 'cart-step']),
    onClick: nextStep
  }, some__picked ? 'Valider et passer à la réservation' : 'Passer cette étape');
  const bottom_action = services_count > 3 || categories?.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "u-full-width u-text-center"
  }, next_btn) : undefined;
  const title_modifiers = ['cart-services'].concat(props['white-label-booking'] ? ['white-label-booking'] : []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, props['white-label-booking'] ? /*#__PURE__*/React.createElement("div", {
    className: bemit('c-direct-booking_header', ['white-label-booking'])
  }, /*#__PURE__*/React.createElement(WhiteLabelReturn, {
    goBack: props.goBack
  }), /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-flat-btn', ['blue', 'v2', 'cart-step-wider']),
    onClick: nextStep
  }, some__picked ? 'Valider et passer à la réservation' : 'Passer cette étape')) : undefined, /*#__PURE__*/React.createElement("div", {
    className: "c-booking-auth__services-top"
  }, /*#__PURE__*/React.createElement("h2", {
    className: bemit('c-title', title_modifiers)
  }, "Les services"), props['white-label-booking'] ? undefined : next_btn), /*#__PURE__*/React.createElement("div", {
    className: "c-booking-auth__services"
  }, services), bottom_action);
}
